import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography, Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useAuthorization from "../../lib/hooks/useAuthorization";
import MenuItem from "./MenuItem";

function MenuGroup({ groupId, title, items, roles, menuOpen }) {
  const localStorageKey = `layout_menugroup_${groupId}`;
  const [expanded, setExpanded] = useState(getInitialState);

  const { authorized } = useAuthorization(roles || []);
  if (roles?.length && !authorized) {
    return;
  }

  function getInitialState() {
    return localStorage.getItem(localStorageKey) === "true";
  }

  function handleOnChange(_, expanded) {
    setExpanded(expanded);
    localStorage.setItem(localStorageKey, expanded);
  }

  return (
    <>
      <Accordion disableGutters square expanded={expanded} onChange={handleOnChange}>
        {menuOpen && (
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant={"body2"} sx={{ color: "text.secondary" }}>
              {title}
            </Typography>
          </AccordionSummary>
        )}

        {!menuOpen && (
          <Tooltip title={title}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ right: 6 }} />
          </Tooltip>
        )}

        <AccordionDetails sx={{ px: 0 }}>
          {items.map((item) => (
            <MenuItem key={item.link} to={item.link} icon={item.icon} label={item.label} roles={item.roles} />
          ))}
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default MenuGroup;
